import { RecoverPasswordService } from 'application/services/recover-password'
import { api } from 'infra/adapters/http-client-adapter'

export const handleRecoverPassword = new RecoverPasswordService(api)
